module.exports = __webpack_public_path__ + "img/KeyPal-Card.89a0aa27.png";